import React from 'react';
import * as ReactDOM from "react-dom/client"
import reactToWebComponent from "react-to-webcomponent";
import Vessels from './components/Vessels';
import './App.css';

function App() {

  return (
    <Vessels></Vessels>
  );
  
}

export default App;

customElements.define("fiskebat-fartoy", reactToWebComponent(App, React, ReactDOM));
